import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toString',
  standalone: true
})
export class ToStringPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return String(value ?? '');
  }
}